import React from 'react';
import PropTypes from 'prop-types';
import Price from '../common/Price';
import {
  addOnsTotals,
  addOnsTotalsPreTax,
  addOnsTotalsTax
} from '../../utils/totals';

export const AddOnTotals = ({ sale, inventory, config }) => {
  const preTax = addOnsTotalsPreTax(sale, inventory);
  const tax = addOnsTotalsTax(sale, inventory);
  const sum = addOnsTotals(sale, inventory);

  return (
    <>
      {!config.taxInclusive && (
        <>
          <div className="swformfield-tktpackage-lineitem-total swformfield-tktpackage-lineitem-total--label">
            <div className="swformfield-tktpackage-lineitem-total__label">
              Subtotal
            </div>
            <div className="swformfield-tktpackage-lineitem-total__total">
              <Price price={preTax} showZero />
            </div>
          </div>
          <div className="swformfield-tktpackage-lineitem-total swformfield-tktpackage-lineitem-total--label">
            <div className="swformfield-tktpackage-lineitem-total__label">
              Tax
            </div>
            <div className="swformfield-tktpackage-lineitem-total__total">
              <Price price={tax} showZero />
            </div>
          </div>
        </>
      )}
      <div className="swformfield-tktpackage-lineitem-total">
        <div className="swformfield-tktpackage-lineitem-total__header">
          Total
        </div>
        <div className="swformfield-tktpackage-lineitem-total__total">
          <Price price={sum} showZero />
        </div>
      </div>
    </>
  );
};

AddOnTotals.propTypes = {
  sale: PropTypes.object,
  inventory: PropTypes.object
};
